import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    IconButton,
    useMediaQuery,
    useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import DrfPrintComponent from './DrfPrintComponent';
import { DrfData } from '../../Pages/AnalisesDrf/types';
import { usePrintDrf } from '../../Hooks/usePrintDrf';

interface DrfPrintPreviewModalProps {
    open: boolean;
    onClose: () => void;
    data: DrfData;
    title: string;
}

const DrfPrintPreviewModal: React.FC<DrfPrintPreviewModalProps> = ({
    open,
    onClose,
    data,
    title
}) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { handlePrint } = usePrintDrf({ data, title });

    const handlePrintAndClose = () => {
        handlePrint();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            fullScreen={fullScreen}
            sx={{
                '& .MuiDialog-paper': {
                    height: fullScreen ? '100%' : '90vh',
                    maxHeight: fullScreen ? '100%' : '90vh'
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderBottom: '1px solid #e0e0e0'
            }}>
                Visualizar Impressão - {title}
                <IconButton
                    aria-label="fechar"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            
            <DialogContent 
                sx={{ 
                    p: 0,
                    overflow: 'auto',
                    backgroundColor: '#f5f5f5'
                }}
            >
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        minHeight: '100%'
                    }}
                >
                    <Box
                        sx={{
                            width: '210mm', // Largura A4
                            minHeight: '297mm', // Altura A4
                            backgroundColor: 'white',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            transform: fullScreen ? 'none' : 'scale(0.8)',
                            transformOrigin: 'top center',
                            '@media print': {
                                transform: 'none',
                                boxShadow: 'none'
                            }
                        }}
                    >
                        <DrfPrintComponent data={data} title={title} />
                    </Box>
                </Box>
            </DialogContent>
            
            <DialogActions sx={{ 
                borderTop: '1px solid #e0e0e0',
                p: 2,
                gap: 1
            }}>
                <Button 
                    onClick={onClose}
                    variant="outlined"
                    color="inherit"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handlePrintAndClose}
                    variant="contained"
                    startIcon={<PrintIcon />}
                    sx={{
                        backgroundColor: '#1976d2',
                        '&:hover': {
                            backgroundColor: '#1565c0'
                        }
                    }}
                >
                    Imprimir
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DrfPrintPreviewModal;
